import React, { FC } from 'react';
import cx from 'classnames';

import { resolveVehiclePhotoBlockIcon } from './VehiclePhotoBlock.helpers';

import styles from './VehiclePhotoBlock.module.scss';

export type VehiclePhotoBlockProps = {
  className?: string;
  icon?: string;
  image?: string | null;
  imageProps?: React.ImgHTMLAttributes<HTMLImageElement>;
  label?: string;
  skippedLabel?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const VehiclePhotoBlock: FC<VehiclePhotoBlockProps> = ({
  className,
  icon,
  image,
  imageProps,
  label,
  skippedLabel,
  ...props
}) => {
  const Icon = resolveVehiclePhotoBlockIcon(icon);

  return (
    <figure
      className={cx(styles.component, className)}
      data-icon={icon}
      {...props}
    >
      {Icon && <Icon data-icon size="large" />}
      {image ? <img alt="" src={image} {...imageProps} /> : null}
      {label ? <figcaption className={styles.label}>{label}</figcaption> : null}
      {skippedLabel ? <figcaption className={styles.skippedLabel}>{skippedLabel}</figcaption> : null}
    </figure>
  );
};
